// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__33cvA","right":"Footer_right__34jT6","buttons":"Footer_buttons__38Zr_"};